export default {
  invoice: {
    billNo: '单据编号',
    invoiceNo: '发票号',
    adddate: '开票时间',
    supOfficeNo: '供应商编号',
    supOfficeName: '供应商名称',
    allTaxAmount: '税额',
    status: '发票状态',
    rejectReason: '驳回原因',
    userName: '发起人',
    allInvoiceAmount: '发票总金额',
    throwStatus: '抛转状态',
    costTypeIn: '入库',
    costTypeOuter: '退货',
    supplierName: '供应商名称',
    purchaseUnitName: '采购中心',
    taxTotalInvoiceAmount: '含税金额',
    noTaxTotalInvoiceAmount: '未税金额',
    invoiceNos: '发票号',
    costDate: '费用产生时间',
    sourceNo: '来源单号',
    sourceSeq: '来源项次',
    costType: '费用类型',
    goodsName: '品名',
    site: '采购中心',
    goodsNo: '料号',
    purchaseSeq: '采购单项次',
    purchasePhaseSeq: '采购单项序',
    purchaseBatchSeq: '采购单分批序',
    unitName: '单位',
    taxRate: '税率（%）',
    valuationUnitName: '计价单位',
    taxPrice: '含税单价',
    originalTaxPrice: '原币含税单价',
    originalTaxAmount: '原币含税总金额',
    originalDiffAmount: '原币税额',
    priceConditionNo: '价格条件',
    payTermsName: '付款条件',
    functionalTaxPrice: '本币含税单价',
    functionalTaxAmount: '本币含税总金额',
    functionalDiffAmount: '本币税额',
    unInvoiceQty: '剩余开票数',
    test: '含税单价',
    qty: '本次开票数',
    diffAmount: '本次税额',
    taxAmountRow: '开票总金额(含税) ',
    noTaxAmountRow: '开票总金额(不含税) ',
    searchPlaceholder: '请输入发票号查询',
    confirmNotThrowSign: '查看已核准未抛转数据',
    dateRange: '开票时间',
    purchaseNo: '订单单号',
    asnNo: '送货单号',
    outBillNo: '抛转对账单号',
    sourceType: '来源单据',
    seqInfo: '项次-项序-分批序',
    currencyName: '币种',
    taxTypeName: '税种',
    priceConditionName: '价格条件',
    invoiceType: '发票类型',
    invoiceClassify: '发票种类',
    invoiceDate: '发票日期',
    invoiceAmount: '发票总金额',
    isGoodsInvoice: '是否为随货发票',
    titles: ['发票信息', '发票明细'],
    btnName: '核准',
    billDate: '费用产生时间',
    residueQty: '剩余开票数',
    taxAmount: '开票金额(含税)',
    noTaxAmount: '开票金额(不含税)',
    tableTitle: '发票明细',
    inputInvoicesRemarksPlaceholder: '请输入发票备注...',
    addTicket: '添加发票',
    deleteTip: '只有待录入状态才能删除',
    nullifyTip: '所购选的数据不能作废',
    confirm: '核准',
    confirmTip: '是否核准？',
    reject: '驳回',
    throwData: '抛转',
    cancelThrowData: '取消抛转',
    throwDataTip: '是否抛转？',
    cancelThrowDataTip: '是否取消抛转？',
    inputInfo: '录入',
    reinputInfo: '重新核准',
    repeatInputInfo: '重新录入',
    supplierNo: '供应商编码',
    diffTotalInvoiceAmount: '税额',
    lookRejectInfo: '驳回原因',
    invoiceCode: '发票代码',
    operation: '操作',
    inputTrueInvoiceNo: '请录入8位数字',
    inputTrueInvoiceCode: '请录入12位数字',
    sumInvoicedAmount: '发票含税金额',
    sumInvoicedNoTaxAmount: '发票未税金额',
    sumInvoicedTaxAmount: '发票税额'
  }
}
